module.exports = __webpack_public_path__ + "img/logo_light.0034d30e.svg";